import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UsersService } from '../../shared/services/users.service'
import { LocationsService } from '../../shared/services/locations.service';
import { HardCopyActivity } from '../models/hard-copy-activity';
import { HardCopyActivityService } from '../services/hard-copy-activity.service';
import { HardCopyConstants } from '../hard-copy.constants';
import { DefaultValueConstants } from '../../shared/constants/default-value-constants';
import { HardcopyActivityCreate } from '../models/hardcopy-activity-create';
import { HardcopyActivityUpdate } from '../models/hardcopy-activity-update';
import { DocumentLibraryConstants } from '../../document/document-library-constants';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, startWith, Subscription, switchMap } from 'rxjs';
import { DocumentService } from '../../document/services/document.service';
import { AssignmentGroupsRequest } from '../../document/models/assignment-groups-request';
import { AssignmentGroupSharedDataService } from '../../shared/services/assignment-group-shared-data.service';

@Component({
  selector: 'app-hard-copy-activity',
  templateUrl: './hard-copy-activity.component.html',
  styleUrls: ['./hard-copy-activity.component.scss'],
})
export class HardCopyActivityComponent implements OnInit {
  // Communication Variables
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() documentStatus !: number;
  @Input() isCreateHardCopyActivitySliderOpen!: boolean;
  @Output() closeHardCopyActivitySlider = new EventEmitter<boolean>();
  @Input() isShowRemovedCopies!: boolean;
  @Input() get activityId(): string {
    return this._activityId;
  }
  sliderHeaderText:string= HardCopyConstants.CreateHCActivityHeader;

  set activityId(val: string) {
    this._activityId = val;
    if (val) this.isEditHardcopySlider();
  }
  @Input()
  get showRemovedCopies(): boolean { return this._showRemovedCopies; }
  set showRemovedCopies(value: boolean) {
    this._showRemovedCopies = value;
  }
  @Output() showRemovedCopiesChange = new EventEmitter<boolean>();

  // Component Variables
  private _showRemovedCopies!: boolean;
  private _activityId!: any;
  hardCopyActivityForm!: FormGroup;
  errorMessages: any = [];
  userList: any = [];
  usersAndAssignmentGroupList : any = []
  usersAndAssignmentGroupListOptions : any = []
  assignmentGroups:any;
  labsites: any = [];
  storageLocations: any = [];
  inactiveAssignments: any = [];
  valueField: string = 'value';
  labelField: string = 'name';
  isEditHardCopyActivity: boolean = false;
  mandatoryFields = this.getDefaultMandatoryFieldsObject();
  hardCopyActivity!: HardCopyActivity;
  defaultCopyValue: number = 1;
  hardcopyActivityDetailsForEdit!: HardCopyActivity;
  hardcopyActivityDetails!: HardCopyActivity;
  hardCopyInfo: any;
  hardcopyActivityBindData: any = {};
  displayRemovedCopies!: boolean;
  maxValueLimit!: any;
  currentlyAssignedUser:any;
  readonly hardcopyAssignmentType = [
    DocumentLibraryConstants.Assignment_types.HardcopyActivity
  ];
  assignmentGroupsSubscription: Subscription | undefined;

  assignedUsersWithInactiveUsers :any = [];
  usersListToValidate:any=[];
  validatedUsersList:any=[];
  inactiveGroupsSelected:any=[];
  InactiveAssignmentGroupField:any;
  isInActiveAssignmentGroupDialog:any;
  hardcopyActivityScope?: number;
  isLoadingAssignmentGroups: boolean = false;


  constructor(private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private usersService: UsersService,
    private locationsService: LocationsService,
    private hardCopyActivityService: HardCopyActivityService,
    private documentsservice: DocumentService,
    private assignmentGroupSharedDataService:AssignmentGroupSharedDataService,
    private cd: ChangeDetectorRef) {
    
  }


  ngOnInit(): void {
   if(!this.isEditHardCopyActivity){
    this.initialize();
   }
    this.hardCopyActivityForm = this.createFormGroupWithBuilderAndModel();
    this.onFormControlChanges();
  }

  isEditHardcopySlider() {
    if(this.labsites.length == 0){
      this.initialize();
      }
      else{
      this.loadEditSliderData();
      }
  }

  loadEditSliderData(){
    // once you have eQMS Scope data, try to bind edit data.
    if (this._activityId && this._activityId.length > 0) {
      this.isEditHardCopyActivity = true;
      this.displayRemovedCopies = this.showRemovedCopies;
      this.loadHardcopyActivitySliderWithDetails(this._activityId);
      this.sliderHeaderText=HardCopyConstants.EditHCActivityHeader;
    }
  }

initialize() {
  if (
    this.labsites.length === 0 &&
    this.documentNumber != null &&
    this.documentVersion != null
  ) {
    this.hardCopyActivityService
      .geteQMSScopesForHardCopyActivity(this.documentNumber, this.documentVersion)
      .subscribe((eQMSscopeData) => {
        for (let dataItem of eQMSscopeData) {
          this.labsites.push({
            value: dataItem.eQMSScopeId,
            name: dataItem.eQMSScopeName
          });
        }
        this.validateeQMSScope();
        this.loadEditSliderData();
      });
  }

  this.locationsService
    .getStorageLocations()
    .subscribe(storageLocationData => this.storageLocations = storageLocationData);
}


  validateeQMSScope(){
    const assignedUserControl = this.hardCopyActivityForm?.get('assignedUser');
    if(this.hardCopyActivityForm.getRawValue().eQMSScope == null || this.hardCopyActivityForm.getRawValue().eQMSScope == undefined){
      this.usersAndAssignmentGroupList = [];
      if (assignedUserControl) {
        assignedUserControl.disable(); 
      }     
    } 
    else{    
      this.inactiveAssignments=  this.inactiveAssignments.filter((data: any)=>data.assignedUserName!== this.currentlyAssignedUser.assignedUserName);
      if(this.hardcopyActivityScope != this.hardCopyActivityForm.getRawValue().eQMSScope){
      this.getAssignedUserList();
      }
      if (assignedUserControl) {
        assignedUserControl.enable(); 
      }        
  }
  }

  getAssignedUserList(){
    if (this.isLoadingAssignmentGroups) {
      return;
    }
    
    this.userList = [];
    this.isLoadingAssignmentGroups = true;
    
    this.usersService.getUsersForHardCopy(this.hardCopyActivityForm.getRawValue().eQMSScope).subscribe(
      (usersData) => {
        if(this.userList.length <= 0){
        for (let dataItem of usersData) {
          this.userList.push({
            value: dataItem.name,
            name: dataItem.name
          });
        }
        }
        if (this.assignmentGroupsSubscription) {
          this.assignmentGroupsSubscription.unsubscribe();
        }
        this.getAssignementGroupsForEachScope();
      },
      (error) => {
        this.isLoadingAssignmentGroups = false;
        console.error('Error fetching users for hardcopy:', error);
      }
    );
  }

  async getAssignementGroupsForEachScope(){
    const eQMSScope = this.hardCopyActivityForm.getRawValue().eQMSScope;
    if (!eQMSScope) {
      this.isLoadingAssignmentGroups = false;
      return;
    }
    const request = new AssignmentGroupsRequest([eQMSScope], this.hardcopyAssignmentType);
    
    // Make immediate call without debounce for initial load
    this.documentsservice.getAssignmentGroups(request).subscribe(
      (assignmentGroups: any) => {
        this.updateUsersAndAssignmentGroupList(assignmentGroups);
        this.isLoadingAssignmentGroups = false;
      },
      (error) => {
        console.error('Error fetching assignment groups:', error);
        this.isLoadingAssignmentGroups = false;
      }
    );
    
    // Set up subscription for future changes only (will trigger on next change)
    this.assignmentGroupsSubscription = this.hardCopyActivityForm.get('eQMSScope')?.valueChanges.pipe(
          // Wait for 500ms of user input before calling the API
          debounceTime(500),
          // Only call the API if the value has changed
          distinctUntilChanged((prev, curr) => {
            const prevLength = prev ? prev.length : 0;
            const currLength = curr ? curr.length : 0;
            return prevLength === currLength && JSON.stringify(prev) === JSON.stringify(curr);
          }),        

          switchMap((eQMSScope) => {
              if (!eQMSScope) {
                this.usersAndAssignmentGroupList = [...this.userList];
                this.usersAndAssignmentGroupListOptions = [...this.usersAndAssignmentGroupList];
                this.sortAssignmentGroupList();
                return EMPTY;
              }
              const request = new AssignmentGroupsRequest([eQMSScope], this.hardcopyAssignmentType);
              return this.documentsservice.getAssignmentGroups(request);
          }),
          catchError((error) => {
            return EMPTY; 
          })
        ).subscribe((assignmentGroups:any) => {
          this.updateUsersAndAssignmentGroupList(assignmentGroups);
    });
  }

  private updateUsersAndAssignmentGroupList(assignmentGroups:any){
    this.assignmentGroups = assignmentGroups;
          this.usersAndAssignmentGroupList = [];
          this.usersAndAssignmentGroupList = [...this.userList];
          for (let ag of assignmentGroups) {
            this.usersAndAssignmentGroupList.unshift({
              value:ag.name,
              name: ag.name,
              id: ag.id
            });
          }
          if (this.inactiveAssignments && this.inactiveAssignments.length > 0) {          
          const groupExists = this.usersAndAssignmentGroupList.find((obj:any) => obj.name == this.inactiveAssignments[0].assignedUserName);
          if (groupExists == undefined) {
              this.usersAndAssignmentGroupList.unshift({
                value: this.inactiveAssignments[0].assignedUserName,
                name: this.inactiveAssignments[0].assignedUserName,
                id: this.inactiveAssignments[0].assignmentId
              });            
            this.cd.detectChanges();
          }  
        }
        this.usersAndAssignmentGroupListOptions = [...this.usersAndAssignmentGroupList];        
        if(this.isEditHardCopyActivity
          && !this.usersAndAssignmentGroupListOptions.find((x:any) => x.value === this.hardCopyInfo.assignedUser.assignedUserName)
        ) {
        this.usersAndAssignmentGroupListOptions.push({
          value : this.hardCopyInfo.assignedUser.assignedUserName,
          name : this.hardCopyInfo.assignedUser.assignedUserName
        });
      }
      this.sortAssignmentGroupList();
    }
 
  private sortAssignmentGroupList() {
    this.usersAndAssignmentGroupList = this.assignmentGroupSharedDataService.sortAssignmentGroupListByName(this.usersAndAssignmentGroupList);
  }

  createFormGroupWithBuilderAndModel() {
    return this.formBuilder.group({
      activity: new FormControl(1, [Validators.required]),
      eQMSScope: new FormControl(null, [Validators.required]),
      storageLocation: new FormControl(null, [Validators.required]),
      copies: new FormControl(1, [Validators.required]),
      assignedUser: new FormControl(null, [Validators.required]),
      notes: new FormControl(),
      removedCopies: new FormControl(null),
      status: new FormControl()
    })
  }

  createHardCopyActivity() {
      if (this.isEditHardCopyActivity) {
          this.validateHardCopyActivityForm();
          if (this.errorMessages.length == 0) {
            this.validateInactiveAssignmentType();
          }
    }
    else
    {
    this.validateHardCopyActivityForm();
    if (this.errorMessages.length == 0) {
      let addedHardcopy = this.mapHardCopyActivityFormToHardcopyActivityForCreate()
      this.hardCopyActivityService.createHardCopyActivity(addedHardcopy).subscribe((response) => {
        this.hardCopyActivity = response;
        this.messageService.add({
            severity: DefaultValueConstants.Severity_Success,
          summary: HardCopyConstants.HardCopyActivity_Created_Success
        });
        this.hardCopyActivityService.hardcopyActivityCreatedOrEdited.next(true);
      })

        this.closeAndResetHardCopyActivitySlider();
      }
    }
  }

  mapHardCopyActivityFormToHardCopyActivity():HardcopyActivityUpdate {
    let formValues = this.hardCopyActivityForm.getRawValue();
    let updateHardcopyActivity : HardcopyActivityUpdate = {
      activity: formValues.activity,
      eQMSScope: formValues.eQMSScope,
      storageLocation: formValues.storageLocation,
      copies: !isNaN(Number(formValues.copies)) ? Number(formValues.copies) : 1,
      assignedUser:this.assignmentGroupSharedDataService.updateUserToAssignmentTypeForHC(this.usersAndAssignmentGroupListOptions, formValues.assignedUser, this.assignmentGroups, this.usersAndAssignmentGroupList),
      notes: formValues.notes,
      removedCopies:!isNaN(Number(formValues.removedCopies)) ? Number(formValues.removedCopies) : null,
      documentVersionPhase : this.documentStatus
    };
    return updateHardcopyActivity;
  }

  mapHardCopyActivityFormToHardcopyActivityForCreate(): HardcopyActivityCreate{
    let formValues = this.hardCopyActivityForm.getRawValue();
    let hardcopyActivityCreate:HardcopyActivityCreate = {
      documentNumber: this.documentNumber,
      documentVersion : this.documentVersion,
      activity : formValues.activity,
      eQMSScope : formValues.eQMSScope,
      storageLocation : formValues.storageLocation,
      copies : !isNaN(Number(formValues.copies)) ? Number(formValues.copies) : 1,
      assignedUser: this.assignmentGroupSharedDataService.updateUserToAssignmentTypeForHC(this.userList, formValues.assignedUser, this.assignmentGroups, this.assignedUsersWithInactiveUsers),
      notes : formValues.notes,
      removedCopies :!isNaN(Number(formValues.removedCopies)) ? Number(formValues.removedCopies) : null,
      documentVersionPhase : this.documentStatus
    };
    return hardcopyActivityCreate;
    }

  confirm() {
    this.confirmationService.confirm({
      message: HardCopyConstants.HardCopyActivity_Confirmation_Text,
      header: HardCopyConstants.HardCopyActivity_Slider_Confirmation_Header,
      icon: "pi pi-exclamation-triangle",
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeAndResetHardCopyActivitySlider();
      }
    });
  }
  getHardCopyActivityStatus(): number {
    let status: number = 0
    if (this.documentStatus === HardCopyConstants.effectiveStatus) status = 1;
    return status;
  }

  closeAndResetHardCopyActivitySlider() {
    this.closeHardCopyActivitySlider.emit(true);
    this.hardCopyActivityForm.reset();
    this.setDefaultsForHardCopyActivityForm();
    this.errorMessages = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    this.showRemovedCopiesChange.emit(false);
    this.isEditHardCopyActivity=false;
    this.sliderHeaderText=HardCopyConstants.CreateHCActivityHeader;
    this.isLoadingAssignmentGroups = false;

  }
  private setDefaultsForHardCopyActivityForm() {
    this.hardCopyActivityForm.controls['copies'].setValue(1);
    this.hardCopyActivityForm.controls['activity'].setValue(1);
  }
  private validateHardCopyActivityForm() {
    this.errorMessages = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    if (this.hardCopyActivityForm.invalid) {
      Object.keys(this.hardCopyActivityForm.controls).forEach(key => {
        if (this.hardCopyActivityForm.get(key)?.errors) {
          let errorText = this.getErrorMessageText(key);
          this.errorMessages.push(errorText);
        }
      });
    }
  }

  private getDefaultMandatoryFieldsObject() {
    return {
      activity: false,
      eQMSScope: false,
      storageLocation: false,
      copies: false,
      assignedUser: false
    };
  }
  private getErrorMessageText(labelName: string) {
    let errorText: string = "";
    switch (labelName) {
      case 'activity':
        errorText = HardCopyConstants.HardCopyActivity_Activity_Required;
        this.mandatoryFields.activity = true;
        break;
      case 'eQMSScope':
        errorText = HardCopyConstants.HardCopyActivity_Location_Required;
        this.mandatoryFields.eQMSScope = true;
        break;
      case 'storageLocation':
        errorText = HardCopyConstants.HardCopyActivity_StorageLocation_Required;
        this.mandatoryFields.storageLocation = true;
        break;
      case 'copies':
        errorText = HardCopyConstants.HardCopyActivity_Copies_Required;
        this.mandatoryFields.copies = true;
        break;
      case 'assignedUser':
        errorText = HardCopyConstants.HardCopyActivity_AssignedUser_Required;
        this.mandatoryFields.assignedUser = true;
        break;
    }
    return errorText;
  }

  private onFormControlChanges() {
    this.hardCopyActivityForm?.get('copies')?.valueChanges.subscribe(copiesValue => {
      if (Number(copiesValue) < 1) {
        this.hardCopyActivityForm?.get('copies')?.setValue(this.defaultCopyValue, { emitEvent: false, onlySelf: true });
      }
    });
  }

  // To set default value to 1 when user provides 
  // input as zero or empty through keyboard
  onCopiesChanges(keyEvent: any) {
    if (Number(keyEvent.target.value) < 1) {
      keyEvent.target.value = 1;
    }
  }

  private loadHardcopyActivitySliderWithDetails(hardcopyActivityID: any) {
    this.hardCopyActivityService.getHardCopyActivityForId(hardcopyActivityID).subscribe(
      documentData => {
        this.hardCopyInfo = documentData;
        this.populateHardcopyActivityDetailsForEdit(this.hardCopyInfo);
      });
  }

  private async populateHardcopyActivityDetailsForEdit(data: any) {
    this.constructEditHardCopyDetails();
    this.hardCopyActivityForm.controls['notes'].setValue(data.notes);
    this.hardCopyActivityForm.patchValue({
      activity: Number(data.activity),
      eQMSScope: Number(data.eQMSScope),
      storageLocation: Number(data.hardcopyStorageLocation),
      copies: data.copies,
      assignedUser: data.assignedUser.assignedUserName,
      notes: data.notes,
      removedCopies: data.removedCopies,
      status: Number(data.status),
    }, { emitEvent: false, onlySelf: true });
    this.maxValueLimit = data.copies;
    this.checkAndAddInactiveUserOrAssignedAdminToUserList(data);
    this.hardcopyActivityScope = this.hardCopyActivityForm.getRawValue().eQMSScope;
    this.validateeQMSScope();
    if(data.activity == HardCopyConstants.HardCopyActivity_Activity_Remove && data.status == HardCopyConstants.HardCopyActivity_ActivityStatus_Done){
      this.disableControls('assignedUser');
    }
  }

 
  

  disableControls(controlNames: string | string[]) {
    if (typeof controlNames === 'string') {
      controlNames = [controlNames];
    }
    controlNames.forEach(controlName => {
      this.hardCopyActivityForm.controls[controlName].disable();      
    });
  }

  checkAndAddInactiveUserOrAssignedAdminToUserList(data: any) {
    const assignedUser = data?.assignedUser;
      if (data?.assignedUser.isActive===false) {
      this.inactiveAssignments.push(assignedUser);
      this.currentlyAssignedUser=assignedUser;     
    }
  }  
 
  private constructEditHardCopyDetails() {
    this.hardcopyActivityDetailsForEdit = JSON.parse(JSON.stringify(this.hardCopyInfo));
    this.hardcopyActivityDetailsForEdit.activity = Number(
      this.populateIdForValue('activity', this.hardCopyInfo?.activity));
    this.hardcopyActivityDetailsForEdit.eQMSScope =
    Number(this.populateIdForValue('eQMSScope', this.hardCopyInfo?.eQMSScope));
    this.hardcopyActivityDetailsForEdit.storageLocation =
      Number(this.populateIdForValue('storageLocation', this.hardCopyInfo?.storageLocation));
    this.hardcopyActivityDetailsForEdit.copies =
      Number(this.populateIdForValue('copies', this.hardCopyInfo?.copies));
    this.hardcopyActivityDetailsForEdit.assignedUser.assignedUserName =
      this.populateIdForValue('assignedUser', this.hardCopyInfo?.assignedUser.assignedUserName);
    this.hardcopyActivityDetailsForEdit.notes =
      this.populateIdForValue('notes', this.hardCopyInfo?.notes);
  }


  private populateIdForValue(fieldType: string, fieldValue?: string) {
    let fieldId = "";
    if (fieldValue == null) return fieldId;

    switch (fieldType) {
      case 'activity':
        fieldId = this.hardcopyActivityBindData.classificationLevel
          ?.find((cl: any) => cl.name == fieldValue).value;
        break;
      case 'eQMSScope':
        fieldId = this.hardcopyActivityBindData.confidentialityLevels
          ?.find((cl: any) => cl.name == fieldValue).value;
        break;
      case 'storageLocation':
        fieldId = this.hardcopyActivityBindData.localLevels
          ?.find((cl: any) => cl.name == fieldValue).value;
        break;
      case 'copies':
        fieldId = this.hardcopyActivityBindData.localTypes
          ?.find((cl: any) => cl.name == fieldValue).value;
        break;
      case 'assignedUser':
        fieldId = this.hardcopyActivityBindData.securities
          ?.find((cl: any) => cl.name == fieldValue).value;
        break;
      case 'notes':
        if (!!fieldValue) {
          fieldId = this.hardcopyActivityBindData.periodicReviewCycles
            ?.find((cl: any) => cl.name == fieldValue).value;
        }
        break;

    }
    return fieldId;
  }

  validateInactiveAssignmentType(){
    const assignedUser = this.hardCopyActivityForm.getRawValue().assignedUser; //With Latest angular upgrade .value will not return the form value of the disabled control hence we need to use .getRawValue()
    const isAssignedUserPresent = this.inactiveAssignments.some((data: any) => data.assignedUserName === assignedUser);
    if(isAssignedUserPresent || !this.usersAndAssignmentGroupList.find((x: any)=> x.value === assignedUser)){
      this.isInActiveAssignmentGroupDialog= true;
      this.InactiveAssignmentGroupField="Assigned User";
    }
    else{
      this.updateHardcopyActivity();
    }

  }

  saveSessionWithInactiveAssignmentGroup(){
    this.isInActiveAssignmentGroupDialog= false;
    this.updateHardcopyActivity();
  }

  closeConfirmationDailog(value: boolean) {
    this.isInActiveAssignmentGroupDialog = value
  }



  updateHardcopyActivity(){
    let updatedHardcopyActivity = this.mapHardCopyActivityFormToHardCopyActivity()
    this.hardCopyActivityService.updateHardCopyActivityForEdit(this.activityId, updatedHardcopyActivity).subscribe(
      (response) => {
        this.hardCopyActivity = response;
        this.messageService.add({
          severity: DefaultValueConstants.Severity_Success,
          summary: HardCopyConstants.HardCopyActivity_Updated_Success
        });
        this.hardCopyActivityService.hardcopyActivityCreatedOrEdited.next(true);
        this.cd.detectChanges();
        this.closeAndResetHardCopyActivitySlider();
      },
      (error)=> {
        this.cd.detectChanges();
        this.closeAndResetHardCopyActivitySlider();
      })
  }
}
